import { useMutation } from 'react-query';

import { ReviewResponse } from '@/features/availability/types';
import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { showNotification } from '@/utils/notificationUtils';

export type requestDTO = {
  data: {
    id?:number;
    comments: string;
    rating: number;
    name?: string;
    businessId?:string;
    token?:string;
  };
  headers : {
    authorization : string;
  }
};

export const addReview = ({ data, headers }: requestDTO): Promise<ReviewResponse> => {
  if(headers && !data.name) {
    return axios.post(`parent/review`, data, {headers});
  }

  return axios.post(`review`, data);
};

type UseUpdateBusinessOptions = {
  config?: MutationConfig<typeof addReview>;
};


export const useAddReview = ({ config }: UseUpdateBusinessOptions = {}) => {
  return useMutation({
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'Review added successfully',
      });
    },
    ...config,
    mutationFn: addReview,
  });
};


